import { Vue } from 'vue-property-decorator';
import { LoadingDataReportCard } from '@/shared/model/briefing-resource.model';
import { map2ResourceItem } from '@/util/mapper-utils';
import { IResourceModel } from '@/shared/model/briefing-widget.model';
import { LOADING_DATA_TYPE, MAX_TIME_OUT_FOR_LOADING_REPORT, MEDIA_LOADING_DATA_TYPE } from '@/constants';

export default class LoadingReportCardUtil extends Vue {
  getLoadingDataReportCardListLocalStorage() {
    return localStorage.getItem('loadingDataReportCardListLocalStorage') || '';
  }

  setLoadingDataReportCardListLocalStorage(dataListInput: any[]) {
    if (dataListInput?.length > 0) {
      localStorage.setItem('loadingDataReportCardListLocalStorage', JSON.stringify(dataListInput));
    } else {
      localStorage.setItem('loadingDataReportCardListLocalStorage', '');
    }
  }

  addLoadingCardToLocalStorage(dataInput: LoadingDataReportCard) {
    const tempList = [dataInput];
    const existingData = this.getLoadingDataReportCardListLocalStorage();

    if (existingData?.length > 0) {
      const parsedData = JSON.parse(existingData);
      const updatedData = [...parsedData, ...tempList];

      this.setLoadingDataReportCardListLocalStorage(updatedData);
    } else {
      this.setLoadingDataReportCardListLocalStorage(tempList);
    }
  }

  handleRemoveLoadingCardByNotifyDataOrAPIData(requestIdsInput: string[]) {
    if (requestIdsInput?.length > 0) {
      const tempData = this.getLoadingDataReportCardListLocalStorage();

      if (tempData?.length > 0) {
        let parsedData = JSON.parse(tempData);

        if (parsedData?.length > 0) {
          parsedData = parsedData.filter((item: LoadingDataReportCard) => !requestIdsInput.includes(item?.requestId));

          if (parsedData?.length > 0) {
            this.setLoadingDataReportCardListLocalStorage(parsedData);
          } else {
            this.setLoadingDataReportCardListLocalStorage([]);
          }
        }
      }
    }
  }

  handleReplaceLoadingReportCardByNotifyData(dataInput: any, originListInput: any[], isForBriefingDetail?: boolean) {
    let tempListReportNotify = [];
    let tempListReportNotifyForView = [];

    if (dataInput && dataInput?.length > 0 && (!dataInput?.status || dataInput?.status !== 'FAIL')) {
      tempListReportNotify = dataInput
        ?.filter(item => item?.parentDocDetail && (item?.requestId || item?.parentDocDetail?.request_id))
        ?.map(item => ({
          ...item,
          requestId: item?.requestId || item?.parentDocDetail?.request_id || '',
        }))
        ?.filter(item => item.requestId !== undefined && item.requestId !== null && item.requestId !== '')
        ?.map(item => ({
          ...item,
          requestId: item?.requestId.concat(this.makeConcatStringByMediaType(item)) || '',
        }))
        ?.filter(item => item.requestId !== undefined && item.requestId !== null && item.requestId !== '');

      if (tempListReportNotify?.length > 0) {
        tempListReportNotifyForView = tempListReportNotify.map(map2ResourceItem) || [];
      }

      if (tempListReportNotifyForView?.length > 0) {
        originListInput = originListInput?.map(currentItem => {
          const matchedTempData = tempListReportNotifyForView.find(tempData => currentItem && currentItem.requestId === tempData.requestId);
          return matchedTempData ? matchedTempData : currentItem;
        });
      }

      if (tempListReportNotify?.length > 0) {
        const tempListReportIdsNotify = tempListReportNotify.map(item => item.requestId);

        this.handleRemoveLoadingCardByNotifyDataOrAPIData(tempListReportIdsNotify);
      }
    } else if (dataInput?.status && dataInput?.status === 'FAIL' && dataInput?.statusCode) {
      originListInput = originListInput?.filter(item => item.requestId !== dataInput.requestId);

      const tempListReportIdsNotify = [dataInput.requestId];

      this.handleRemoveLoadingCardByNotifyDataOrAPIData(tempListReportIdsNotify);
    }

    if (tempListReportNotifyForView?.length > 0 && isForBriefingDetail !== undefined && isForBriefingDetail === true) {
      if (originListInput?.length > 0) {
        const tempList = tempListReportNotifyForView.filter(
          item => !originListInput.some(originItem => originItem.requestId === item.requestId)
        );

        originListInput.unshift(...tempList);
      } else {
        originListInput = [...tempListReportNotifyForView];
      }
    }

    return originListInput;
  }

  handleRemoveLoadingReportCardWithListInput(originListInput: any[]) {
    if (originListInput?.length > 0) {
      const tempListRequestId = originListInput
        ?.filter(
          item =>
            item.type === 'REPORT' &&
            (item.originParentDocDetail || item.parentDocDetail) &&
            (item.isLoadingCard === undefined || item.isLoadingCard === false)
        )

        ?.map(item => item?.requestId?.concat(this.makeConcatStringByMediaType(item)) || '')
        .filter(item => item !== null && item !== undefined && item !== '');

      const firstExistingLoadingData = this.getLoadingDataReportCardListLocalStorage();

      if (firstExistingLoadingData?.length > 0) {
        const firstParsedData = JSON.parse(firstExistingLoadingData);

        if (firstParsedData?.length > 0) {
          if (tempListRequestId?.length > 0) {
            this.handleRemoveLoadingCardByNotifyDataOrAPIData(tempListRequestId);
          }
        }
      }
    }
  }

  handleAddLoadingReportCardToListView(originListInput: any[], originBpIdInput: string) {
    const existingLoadingData = this.getLoadingDataReportCardListLocalStorage();
    // console.log('originListInput: ', originListInput);

    if (existingLoadingData?.length > 0) {
      const parsedData = JSON.parse(existingLoadingData);

      if (parsedData?.length > 0) {
        // console.log('parsedData: ', parsedData);
        const tempLoadingDataReportList = [];

        parsedData.forEach(loadingDataReportItem => {
          const tempObject: IResourceModel = {
            docId: undefined,
            type: 'REPORT',
            mediaType: '',
            isLoadingCard: true,
            requestId: loadingDataReportItem.requestId || '',
            bpId: loadingDataReportItem.bpId || '',
          };

          if (
            tempObject &&
            tempObject.bpId === originBpIdInput &&
            new Date().getTime() - loadingDataReportItem.addedTime < MAX_TIME_OUT_FOR_LOADING_REPORT &&
            tempObject.requestId !== ''
          ) {
            const isExitedLoadingCard = originListInput?.some(item => item.requestId === tempObject.requestId);

            if (isExitedLoadingCard !== undefined && isExitedLoadingCard === false) {
              // console.log('add tempObject: ', tempObject);
              tempLoadingDataReportList.unshift(tempObject);
            }
          }
        });

        if (tempLoadingDataReportList?.length > 0) {
          originListInput = [...tempLoadingDataReportList, ...originListInput];
          // console.log('last originListInput return: ', originListInput);
        }
      }
    }

    return originListInput;
  }

  handleRemoveLoadingReportCardByRequestIds(requestIdInput: string) {
    let isOverTime = false;
    const existingLoadingData = this.getLoadingDataReportCardListLocalStorage();

    if (existingLoadingData?.length > 0) {
      const parsedData = JSON.parse(existingLoadingData);

      if (parsedData?.length > 0) {
        const existedData = parsedData.find(item => item.requestId === requestIdInput);

        if (existedData && existedData.requestId) {
          if (new Date().getTime() - existedData.addedTime < MAX_TIME_OUT_FOR_LOADING_REPORT) {
            isOverTime = false;
          } else {
            isOverTime = true;
          }
        } else {
          isOverTime = true;
        }
      } else {
        isOverTime = true;
      }
    } else {
      return true;
    }

    if (isOverTime === true) {
      this.handleRemoveLoadingCardByNotifyDataOrAPIData([requestIdInput]);
    }

    return isOverTime;
  }

  handleRemoveLoadingReportCardFromListView(dataInput: any, originListInput: any[]) {
    let tempListReportNotify = [];
    let tempListReportNotifyForView = [];

    if (dataInput && dataInput?.length > 0 && (!dataInput?.status || dataInput?.status !== 'FAIL')) {
      tempListReportNotify = dataInput
        ?.filter(item => item?.parentDocDetail && (item?.requestId || item?.parentDocDetail?.request_id))
        ?.map(item => ({
          ...item,
          requestId: item?.requestId || item?.parentDocDetail?.request_id || '',
        }))
        ?.filter(item => item.requestId !== undefined && item.requestId !== null && item.requestId !== '');

      if (tempListReportNotify?.length > 0) {
        tempListReportNotifyForView = tempListReportNotify.map(map2ResourceItem) || [];
      }

      if (tempListReportNotifyForView?.length > 0) {
        originListInput = originListInput?.filter(currentItem => {
          return !tempListReportNotifyForView.some(tempData => currentItem && currentItem.requestId === tempData.requestId);
        });
      }

      // if (tempListReportNotify?.length > 0) {
      //   const tempListReportIdsNotify = tempListReportNotify.map(item => item.requestId);
      //
      //   this.handleRemoveLoadingCardByNotifyDataOrAPIData(tempListReportIdsNotify);
      // }
    } else if (dataInput?.status && dataInput?.status === 'FAIL' && dataInput?.statusCode) {
      originListInput = originListInput?.filter(item => item.requestId !== dataInput.requestId);

      // const tempListReportIdsNotify = [dataInput.requestId];
      //
      // this.handleRemoveLoadingCardByNotifyDataOrAPIData(tempListReportIdsNotify);
    }

    return originListInput;
  }

  makeConcatStringByMediaType(item: any) {
    if (!item) {
      return '';
    }

    let result = '';
    const prefix = '_';
    const mediaType =
      item?.originParentDocDetail?.media_type ||
      item?.mediaType ||
      item?.parentDocDetail?.mediaType ||
      item?.parentDocDetail?.media_type ||
      [];

    const mediaTypeArray = Array.isArray(mediaType) ? mediaType : [];

    if (mediaTypeArray.length > 0) {
      const hasJournalNote = mediaTypeArray.some(type => type && type.includes(MEDIA_LOADING_DATA_TYPE.JOURNAL_NOTE.toString()));
      const hasSocialMedia = mediaTypeArray.some(type => type && type.includes(MEDIA_LOADING_DATA_TYPE.SOCIAL_MEDIA.toString()));
      const hasPodcast = mediaTypeArray.some(type => type && type.includes(MEDIA_LOADING_DATA_TYPE.PODCAST.toString()));
      const hasReport = mediaTypeArray.some(type => type && type.includes(MEDIA_LOADING_DATA_TYPE.REPORT.toString()));

      if (hasJournalNote) {
        result = LOADING_DATA_TYPE.JOURNALIST_NOTE.toString();
      } else if (hasSocialMedia) {
        result = LOADING_DATA_TYPE.SOCIAL_MEDIA_POSTING.toString();
      } else if (hasPodcast) {
        result = LOADING_DATA_TYPE.PODCAST.toString();
      } else if (hasReport) {
        result = LOADING_DATA_TYPE.REPORT.toString();
      }

      if (result?.length > 0) {
        result = result.replace(/^_+/, '');
        result = prefix + result;
      }
    }

    return result;
  }
}
